import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { MapPin, Clock, Award, Shield, Phone, Star } from "lucide-react";

export const Hero = () => {
  // Add JSON-LD structured data for local business
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "InsuranceAgency",
    "name": "Allen Insurance Agency",
    "description": "Full-service insurance agency providing auto, home, business, and life insurance in Illinois.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Illinois",
      "addressRegion": "IL",
      "addressCountry": "US"
    },
    "areaServed": {
      "@type": "State",
      "name": "Illinois"
    },
    "offers": {
      "@type": "Offer",
      "itemOffered": [
        {
          "@type": "Service",
          "name": "Auto Insurance"
        },
        {
          "@type": "Service",
          "name": "Home Insurance"
        },
        {
          "@type": "Service",
          "name": "Business Insurance"
        },
        {
          "@type": "Service",
          "name": "Life Insurance"
        }
      ]
    }
  };

  return (
    <section className="relative py-6 md:py-12 overflow-hidden bg-white">
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <div className="flex flex-wrap gap-2 justify-center mb-6">
            <Badge variant="default" className="flex items-center gap-1">
              <MapPin className="h-4 w-4" />
              Local Illinois Agency
            </Badge>
            <Badge variant="secondary" className="flex items-center gap-1">
              <Phone className="h-4 w-4" />
              24/7 Support
            </Badge>
            <Badge variant="outline" className="flex items-center gap-1">
              <Shield className="h-4 w-4" />
              50 Years Experience
            </Badge>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-dark mb-6">
            Illinois Insurance Experts: Auto, Home, Business & Life Coverage
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed">
            Get personalized insurance quotes tailored to your needs. Protect what matters most with comprehensive coverage from your trusted local insurance provider in Illinois.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/quote">
              <Button size="lg" className="w-full sm:w-auto text-white">
                Quick Quote
              </Button>
            </Link>
            <Link to="/quote">
              <Button variant="outline" size="lg" className="w-full sm:w-auto">
                Get Started
              </Button>
            </Link>
          </div>
          <div className="mt-8 text-sm text-muted-foreground">
            <p>Serving Illinois with comprehensive insurance solutions:</p>
            <p className="mt-2">
              Auto Insurance • Home Insurance • Business Insurance • Life Insurance
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};